import { createWithEqualityFn } from 'zustand/traditional';
import { config } from '@shakkerai/config';
import { getTagList } from '@shakkerai/services';
import { MODEL_SDXL } from '@shakkerai/pro-models';

const isOverseas = config.env === 'aws';
const globalMode = localStorage.getItem('__MODE_SETTINGS_Key__') || 'simple';
export const SHARE_PIC_FLAG = '1';
export const _useTempState = createWithEqualityFn((set) => ({
  canvasAction: 'select',
  topImagesTool: '',
  globalMode: globalMode, // 全局模式:simple/pro
  simpleBaseType: MODEL_SDXL,
  dragging: false,
  spacePressing: false,
  hideCheckpointPreset: false,
  promptLang: isOverseas ? 'en' : 'zh',
  promptSettingsParams: {
    prompt_setting_enhance: true,
    auto_complete: true,
    two_language: true,
  },
  imageFeedbackWindowId: null,
  selectedFeedbackElement: null,
  presetCheckpoint: null,
  sendToGelleryModel: null,
  selectionRect: null,
  referenceTempUrl: null,
  referenceUploadProgress: -1,
  freshUploadProgress: -1,
  lastGeneratorId: null,
  galleryOpened: false,
  styleEnhanceModel: null, // 风格强化
  selectedEnhanceStyle: null,
  loraEnhanceData: {
    loraEnhanceWord: '',
    loraEnhanceModel: null,
  }, // 角色强化
  tags: [],
  showLoraAddedTip: false,
  showCheckpointAddedTip: false,
  showNormalCkptGide: false,
  newerGuideTipOpen: false,
  firstGeneratedDoneFlag: false,
  from: '',
  updateTempState: (partialState) => set(partialState),
  updateSharePicTipsState: (partialState) => set(partialState),
  getTagList() {
    getTagList({ tagType: 2 }).then((res) => {
      if (res.data?.length > 0) {
        set({ tags: res.data || [] });
      }
    });
  },
  collageGeneratorId: null,
  isShowSharePicTips: false,

  selection: [],
}));

export const useTempState = (field) => {
  if (field === false) {
    return _useTempState.getState();
  }

  return _useTempState(field ? (state) => state[field] : undefined);
};

export const queryTags = () => {
  const state = _useTempState.getState();
  return state.getTagList();
};

export const updateTempState = (partialState) => {
  _useTempState.setState(partialState);
};

// 控制右上角histroy按钮，是否有popover展示
export const updateSharePicTipsState = (partialState) => {
  const flag = localStorage.getItem('_IS_SHOW_SHARE_PIC_FLAG_');
  // TODO 目前限制国内不要操作，如果不限制，去掉isOverseas
  if (flag !== SHARE_PIC_FLAG && isOverseas) {
    _useTempState.setState(partialState);
    localStorage.setItem('_IS_SHOW_SHARE_PIC_FLAG_', SHARE_PIC_FLAG);
  }
};

export const getTempState = (fieldName) => {
  return fieldName ? _useTempState.getState()[fieldName] : _useTempState.getState();
};
